import request from "../clientsApi";
import { API_ROUTES } from "../../config/baseURL";

export const codificacionApi = {
  getAll: async (consecutivo = "") => {
    const res = await request(API_ROUTES.getCodificacion(consecutivo), {
      method: "GET",
    });
    return res.json();
  },

  getById: async (id) => {
    const res = await request(API_ROUTES.getCodificacionById(id), {
      method: "GET",
    });
    return res.json();
  },

  save: async (payload) => {
    const isUpdate = !!payload.id;
    const res = await request(API_ROUTES.saveCodificacion, {
      method: isUpdate ? "PUT" : "POST",
      body: JSON.stringify(payload),
    });
    return res.json();
  },

  delete: async (id) => {
    const res = await request(API_ROUTES.deleteCodificacion, {
      method: "POST",
      body: JSON.stringify({ id }),
    });
    return res.json();
  },

  // Manejo de opciones (ValorCodificacion)
  addValor: async (payload) => {
    const res = await request(API_ROUTES.addValorCodificacion, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return res.json();
  },

  updateValor: async (payload) => {
    const res = await request(API_ROUTES.updateValorCodificacion, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
    return res.json();
  },

  deleteValor: async (id) => {
    const res = await request(API_ROUTES.deleteValorCodificacion, {
      method: "POST",
      body: JSON.stringify({ id }),
    });
    return res.json();
  },
};

export default codificacionApi;

